import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(false));
  }, []);

  const signIn = useCallback(async (path, body) => {
    const { data } = await api.post(path, body);
    sessionStorage.setItem("kag_token", data.token);
    const { token, ...u } = data;
    setUser(u);
    return u;
  }, []);

  const login = useCallback((email, password) => signIn("/auth/login", { email, password }), [signIn]);
  const register = useCallback((name, email, password) => signIn("/auth/register", { name, email, password }), [signIn]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* session already gone */ }
    sessionStorage.removeItem("kag_token");
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
